import { render, staticRenderFns } from "./PopupSliderSwitch.vue?vue&type=template&id=69cff5d2&"
import script from "./PopupSliderSwitch.vue?vue&type=script&lang=js&"
export * from "./PopupSliderSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports